import React ,{ useEffect } from 'react';
import { useCart } from '../app/CartContext';
// import { XMarkIcon, TrashIcon, PlusIcon, MinusIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom'
import iconClose from '../assets/images/icon_close.png'
import iconDel from '../assets/images/icon_del.png'
import emptyCart from '../assets/images/cart-empty.png'


const CartSidebar: React.FC = () => {
  const { state, removeItem, updateQuantity, closeCart } = useCart();
  const navigate = useNavigate();

  const formatPrice = (price: number) => {
    return `NT$${price.toLocaleString()}`;
  };

  // 防止購物車滾動影響背景頁面
  // const handleCartScroll = (e: React.WheelEvent) => {
  //   e.stopPropagation();
  // };

  // // 防止購物車內容的滾動事件傳播
  // const handleContentScroll = (e: React.UIEvent) => {
  //   e.stopPropagation();
  // };
  useEffect(() => {
    if (state.isOpen) {
      const scrollBarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, [state.isOpen]);
  if (!state.isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-[#00000066] z-[999]" onClick={closeCart}>
        <div className="bg-white fixed top-0 right-0 w-full max-w-[334px] h-full flex flex-col " onClick={(e) => {e.stopPropagation();}}>  
          <div className="p-6 flex items-center justify-between border-b">
            <p className='text-h6'>購物車({state.items.length})</p>
            <button type="button" onClick={closeCart} className="flex items-center justify-center w-6 h-6">
              <img src={iconClose} className="w-[24px]" alt="關閉購物車" />
            </button>
          </div>
          <div className="p-6 flex-1 overflow-y-auto min-h-0">
            {state.items.length === 0 ? (
              <div className="h-full flex flex-col items-center justify-center ">
                <img src={emptyCart} className='w-[100px] mb-4'  alt="" />
                <p className="text-gray-500 text-lg mb-8">購物車空空的</p>
                <button className='bg-primary text-white text-button-m w-full py-4 rounded-full mb-3' type="button">前往探索特色課程</button>
              </div>
            ) : (
              <>
                {state.items.map((item) => (
                  <div key={item.id} className="flex items-start justify-between mb-6">
                    <div className='flex flex-1 min-w-0'>
                      <div className='w-[80px] h-[80px] rounded mr-4 flex-shrink-0 bg-cover bg-center bg-no-repeat' style={{ backgroundImage: `url(${item.image})` }}></div>
                      <div className='grid gap-2 w-full min-w-0'>
                        <div className="flex justify-between items-center">
                          <p className='text-subtitle-s text-[#0B1418] line-clamp-2'>{item.title}</p>
                          <button type="button" className='w-[18px] flex-shrink-0' onClick={() => removeItem(item.id)}>
                            <img src={iconDel} alt="" />
                          </button>
                        </div>
                        <p className='text-warning font-bold'>{formatPrice(item.price)}</p>
                        <div className='w-[calc(100%-22px)] border rounded flex items-center'>
                          <button className="flex p-[7px]" onClick={() => updateQuantity(item.id, item.quantity - 1)} disabled={item.quantity <= 1}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                              <path d="M15 9L3 9" stroke={item.quantity <= 1?'#B5BAC1':'#4C4E51'} stroke-width="1.5" stroke-linecap="round"/>
                          </svg>
                          </button>
                          <div className="w-full text-center">{item.quantity}</div>
                          <button className="flex p-[7px]" onClick={() => updateQuantity(item.id, item.quantity + 1)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M9 3V15M15 9L3 9" stroke="#4C4E51" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
          {state.items.length !== 0 &&
            <div className="w-full px-4 border-t pt-5 pb-9">
              <div className="flex items-center justify-between mb-5">
                <p className='text-h6'>總計</p>
                <p className='text-h6 text-warning'>{formatPrice(state.total)}</p>
              </div>
              <button className='bg-primary text-white text-button-m w-full py-4 rounded-full mb-3' type="button" onClick={() => {navigate('/order/checkout'); closeCart()}}>前往結帳</button>
              <p className='text-body-xs text-secondary text-center'>結帳後將發送電子票券至您的手機</p>
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default CartSidebar;
